{
  "CHAT_LIST": {
    "LOADING": "Nahrávam konverzácie",
    "LOAD_MORE_CONVERSATIONS": "Načítavam viac konverzácií",
    "EOF": "Všetky konverzácie boli načítané 🎉",
    "LIST": {
      "404": "V tejto skupine neprebiehajú žiadne aktívne rozhovory."
    },
    "FAILED_TO_SEND": "Failed to send",
    "TAB_HEADING": "Rozhovory",
    "MENTION_HEADING": "Zmienky",
    "UNATTENDED_HEADING": "Unattended",
    "SEARCH": {
      "INPUT": "Vyhľadávanie ľudí, konverzácií, uložených odpovedí.."
    },
    "FILTER_ALL": "Všetko",
    "ASSIGNEE_TYPE_TABS": {
      "me": "Moje",
      "unassigned": "Nepriradené",
      "all": "Všetko"
    },
    "CHAT_STATUS_FILTER_ITEMS": {
      "open": {
        "TEXT": "Otvorené"
      },
      "resolved": {
        "TEXT": "Vyriešené"
      },
      "pending": {
        "TEXT": "Čaká sa na"
      },
      "snoozed": {
        "TEXT": "Odložené"
      },
      "all": {
        "TEXT": "Všetko"
      }
    },
    "VIEW_FILTER": "Zobraziť",
    "SORT_TOOLTIP_LABEL": "Sort conversations",
    "CHAT_SORT": {
      "STATUS": "Status",
      "ORDER_BY": "Order by"
    },
    "CHAT_TIME_STAMP": {
      "CREATED": {
        "LATEST": "Created",
        "OLDEST": "Created at:"
      },
      "LAST_ACTIVITY": {
        "NOT_ACTIVE": "Last activity:",
        "ACTIVE": "Last activity"
      }
    },
    "SORT_ORDER_ITEMS": {
      "last_activity_at_asc": {
        "TEXT": "Last activity: Oldest first"
      },
      "last_activity_at_desc": {
        "TEXT": "Last activity: Newest first"
      },
      "created_at_desc": {
        "TEXT": "Created at: Newest first"
      },
      "created_at_asc": {
        "TEXT": "Created at: Oldest first"
      },
      "priority_desc": {
        "TEXT": "Priority: Highest first"
      },
      "priority_asc": {
        "TEXT": "Priorita: od najnižšej"
      },
      "waiting_since_asc": {
        "TEXT": "Pending Response: Longest first"
      },
      "waiting_since_desc": {
        "TEXT": "Pending Response: Shortest first"
      },
      "priority_desc_created_at_asc": {
        "TEXT": "Priority: Highest first, Created: Oldest first"
      }
    },
    "ATTACHMENTS": {
      "image": {
        "CONTENT": "Obrázková správa"
      },
      "audio": {
        "CONTENT": "Hlasová správa"
      },
      "video": {
        "CONTENT": "Video správa"
      },
      "file": {
        "CONTENT": "Súbor v prílohe"
      },
      "location": {
        "CONTENT": "Lokácia"
      },
      "ig_reel": {
        "CONTENT": "Instagram Reel"
      },
      "fallback": {
        "CONTENT": "zdieľal/a url"
      },
      "contact": {
        "CONTENT": "Shared contact"
      },
      "embed": {
        "CONTENT": "Embedded content"
      }
    },
    "CHAT_SORT_BY_FILTER": {
      "TITLE": "Sort conversation",
      "DROPDOWN_TITLE": "Sort by",
      "ITEMS": {
        "LATEST": {
          "NAME": "Last activity at",
          "LABEL": "Last activity"
        },
        "CREATED_AT": {
          "NAME": "Created at",
          "LABEL": "Created at"
        },
        "LAST_USER_MESSAGE_AT": {
          "NAME": "Last user message at",
          "LABEL": "Last message"
        }
      }
    },
    "RECEIVED_VIA_EMAIL": "Prijaté emailom",
    "VIEW_TWEET_IN_TWITTER": "Zobraz tweet na Twitteri",
    "REPLY_TO_TWEET": "Odpovedať na tento Tweet",
    "LINK_TO_STORY": "Go to instagram story",
    "SENT": "Úspešne odoslané",
    "READ": "Read successfully",
    "DELIVERED": "Delivered successfully",
    "NO_MESSAGES": "Žiadne správy",
    "NO_CONTENT": "Žiaden obsah nie je k dispozícii",
    "HIDE_QUOTED_TEXT": "Skryť citovaný text",
    "SHOW_QUOTED_TEXT": "Ukázať citovaný text",
    "MESSAGE_READ": "Read",
    "SENDING": "Sending",
    "UNREAD_COUNT_OVERFLOW": "9+"
  }
}
